module.exports = __webpack_public_path__ + "img/group_avator.244b74a4.png";